import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomeView.vue'
import Todo from '../views/TodoView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/todo',
    name: 'todo',
    component: Todo,
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
